import { connect } from 'react-redux';
import { AppState } from '../store';
import InitialTemplate from '../components/template/InitialTemplate';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as Actions from '../modules/index/actions';
import * as module from '../modules/index/index';
import * as propertyModule from '../modules/property';
import * as propertyActions from '../modules/property/actions';

export const mapStateToProps = (state: AppState) => {
  return {
    property: state.property.property,
    propertyStatus: state.property.status,
    status: state.index.status,
    identificationStatus: state.identification.status,
    invitationStatus: state.invitation.status
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch<AppState, {}, AnyAction>) => ({
  setQueryParams: (organizationId: string, usageInfoId: string, peopleId: string) => {
    dispatch(propertyActions.setOrganizationId(organizationId));
    dispatch(propertyActions.setUsageInfoId(usageInfoId));
    dispatch(propertyActions.setPeopleId(peopleId));
    dispatch(Actions.setQueryParams());
  },
  invalidQueryParams: () => dispatch(Actions.invalidQueryParams()),
  getProperty: () => dispatch(propertyModule.operations.getProperty()),
  saveQueryToCookie: () => dispatch(module.operations.saveQueryParamsToCookie())
});

export default connect(mapStateToProps, mapDispatchToProps)(InitialTemplate);
